import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import { Link } from "react-router-dom"

const NoInfoLayout = ({ children, title }) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <Box contain>
      <Typography
        color="neutral"
        fontSize="14px"
        light
        mx={{ _: 2, tablet: "auto" }}
        my={3}
        textAlign="left"
      >
        <Link data-lc="no-info-layout" to="/">
          Home
        </Link>{" "}
        / {title}
      </Typography>
    </Box>
    {children}
  </>
)

NoInfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  layout: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default NoInfoLayout
